export const StorefrontUrl = import.meta.env.VITE_STOREFRONT_API_URL;

export const getStorefrontUrl = (path: string) => {
  return new URL(path, StorefrontUrl);
};
